<div style='margin-top:10px;padding:0px'>
    <div style='background-color: silver;' fxLayout='row' fxLayoutAlign='start'>
        <span class='name' fxFlex>Holes</span>
        <span class='score' fxFlex [fxShow.xs]='showOnMobile()' *ngFor='let hole of courseInfo.front'>{{hole.holeNumber}}</span>
        <span class='out' fxFlex>Out </span>
        <span class='score' fxFlex [fxShow.xs]='showOnMobile()' *ngFor='let hole of courseInfo.back'>{{hole.holeNumber}}</span>
        <span class='out' fxFlex>In</span>
        <span class='total' fxFlex>Total</span>
    </div>
</div>
<div style='padding:0px'  [fxShow.xs]='showOnMobile()'>
    <div style='background-color: grey;color:white' fxLayoutAlign='row' fxLayoutAlign='start'>
        <span class='name' fxFlex>Handicap</span>
        <span class='score' fxFlex *ngFor='let hole of courseInfo.front'>{{hole.handicap}}</span>
        <span class='out' fxFlex> &nbsp;</span>
        <span class='score' fxFlex *ngFor='let hole of courseInfo.back'>{{hole.handicap}}</span>
        <span class='out' fxFlex> &nbsp;</span>
        <span class='total' fxFlex> &nbsp;</span>
    </div>
</div>
<div style='padding:0px'>
    <div style='background-color: silver;' fxLayout='row' fxLayoutAlign='start'>
        <span class='name' fxFlex>Par</span>
        <span class='score' fxFlex [fxShow.xs]='showOnMobile()' *ngFor='let hole of courseInfo.front'>{{hole.par}}</span>
        <span class='out' fxFlex> {{courseInfo.parFront}}</span>
        <span class='score' fxFlex [fxShow.xs]='showOnMobile()' *ngFor='let hole of courseInfo.back'>{{hole.par}}</span>
        <span class='out' fxFlex> {{courseInfo.parBack}} </span>
        <span class='total' fxFlex> {{courseInfo.parFront + courseInfo.parBack}}</span>
    </div>
</div>